"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProductsList;
var React = require("react");
var ProductCompare_1 = require("./ProductCompare");
var Portal_1 = require("../Portal");
function ProductsList(props) {
    if (!props.products.length) {
        return null;
    }
    var products = props.products, toggleFavAction = props.toggleFavAction, favourites = props.favourites, state = props.state;
    return products.map(function (product) {
        return (React.createElement(Portal_1.default, { key: product.ARIDENT, id: product.ARIDENT },
            React.createElement(ProductCompare_1.default, __assign({ product: product }, props))));
    });
}
